import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { getCurrentDate } from '../../../helpers/Common';
import { REDUCER_NAME, downloadTopForeignTrading } from './reducer';
import ExportBlob from '../../../common/export-blob';
import Const from '../Const';

class ExportCommon extends React.Component {
  handleExport = () => {
    const { filter, downloadTopForeignTrading, typeTab, option } = this.props;
    if (typeTab === 5) return;

    const apiParams = {
      ComGroupCode: filter,
      Option: option,
      Screen: Const.screen[typeTab],
    };
    const name = `${I18n.t(`common.export.topMover.${typeTab}`, {
      date: getCurrentDate(),
      name: I18n.t('common.listComponent.TopForeignTrade'),
    })}`;

    downloadTopForeignTrading(apiParams, name);
  };

  render() {
    return <ExportBlob handleExport={this.handleExport} />;
  }
}

const mapStateToProps = state => {
  return {
    option: state[REDUCER_NAME].option,
    i18n: state.i18n,
  };
};

const mapDispatchToProps = {
  downloadTopForeignTrading,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExportCommon);
